import React from "react";
import { AntdPrimaryButton } from "./styles";

export default function PrimaryButton({ ...props }) {
	return <AntdPrimaryButton {...props} />;
}
